import { COLLECTION_TITLE_SETTING } from '@/constants/modules/collection-title';
import { COLLECTION_DESC_SETTING } from '@/constants/modules/collection-desc';
// import { COLLECTION_TOOLBAR_SETTING } from "@/constants/modules/collection-toolbar";
// import { PAGINATOR_SETTING } from "@/constants/modules/paginator";
export const SETTING_COLLECTIONS = {
  'collection-title': COLLECTION_TITLE_SETTING,
  'collection-desc': COLLECTION_DESC_SETTING,
  // "collection-toolbar": COLLECTION_TOOLBAR_SETTING,
  // "paginator": PAGINATOR_SETTING,
};
